import { useEffect } from "react";

/** The auth screen's darkest colour, the end of its page gradient (LoginPage). */
export const AUTH_PAGE_BASE = "#0d0a12";
/** The colour at the top of the auth screen, where the purple glow sits. */
export const AUTH_PAGE_TOP = "#221735";

/**
 * The auth screen is dark in both themes, but the document behind it follows the app theme, so on a light
 * phone iOS Safari painted its status-bar and toolbar areas (and the overscroll) white around the dark page.
 * While the screen is open the document takes the screen's colours: the html/body background for the
 * toolbar and overscroll, and `theme-color` for browsers that tint their bars from it. Everything is put back
 * on unmount.
 */
export function useAuthPageBrowserChrome(): void {
  useEffect(() => {
    const { documentElement: html, body } = document;
    const previous = { html: html.style.backgroundColor, body: body.style.backgroundColor };
    html.style.backgroundColor = AUTH_PAGE_BASE;
    body.style.backgroundColor = AUTH_PAGE_BASE;

    const existing = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    const meta = existing ?? document.head.appendChild(Object.assign(document.createElement("meta"), { name: "theme-color" }));
    const previousTheme = existing?.content ?? null;
    meta.content = AUTH_PAGE_TOP;

    return () => {
      html.style.backgroundColor = previous.html;
      body.style.backgroundColor = previous.body;
      if (previousTheme === null) meta.remove();
      else meta.content = previousTheme;
    };
  }, []);
}
